module.exports = __webpack_public_path__ + "static/media/Manfred.83e4a15d.png";